import { Box, Flex, Text, Link as ChakraLink, Button } from '@chakra-ui/react'
import Image, { StaticImageData } from 'next/image';
import { CategoryData } from '@/Types/types';
import useTranslation from 'next-translate/useTranslation';
import Link from 'next/link';
import { useEffect, useState } from 'react';

import adsHair from "@/img/ads/ads-hair.png"
import adsNails from "@/img/ads/ads-nails.png"
import adsPosts from "@/img/ads/ads-posts.png"

interface Props {
  postCategories: Record<"attributes", CategoryData>[];
}

interface AdsData {
  href: string;
  src: StaticImageData;
  alt: string;
}

export default function AdsMobile({ postCategories }: Props) {
  const [isAdVisible, setIsAdVisible] = useState<Boolean>(true);
  const [currentAd, setCurrentAd] = useState<AdsData>({
    href: "https://go.hotmart.com/Y85471404N",
    src: adsPosts,
    alt: "O segredo da Automaquiagem",
  });

  const { t } = useTranslation("common");

  const handleAdClose = () => {
    setIsAdVisible(false);
  };

  const handleAdOpen = () => {
    setIsAdVisible(true);
  };

  useEffect(() => {
    postCategories.find((category) => {
      if (category.attributes.slug === "cabelos") {
        setCurrentAd({
          href: "https://go.hotmart.com/X85472058X",
          src: adsHair,
          alt: "[E-book] Os segredos do Cronograma Capilar",
        });
      } else if (category.attributes.slug === "unhas") {
        setCurrentAd({
          href: "https://go.hotmart.com/F85472375W",
          src: adsNails,
          alt: "Nail Academy: do iniciante ao avançado! ",
        });
      }
    });
  }, []);


  return (
    <>
      {!isAdVisible ? (
        <Button 
          aria-label='see ad'
          p="4px 17px" borderTop="1px solid #E2E8F0" borderX="1px solid #E2E8F0" borderRadius="8px 8px 0px 0px" bgColor="white" fontSize="12px" lineHeight="16px" fontWeight="500" position="fixed" bottom="0" left="50%" transform={"translateX(-50%)"} onClick={handleAdOpen}>
          {t("article.advertising.seeAd")}
        </Button>
      ) : (
        <Flex w="100%" position="fixed" bottom="0" direction="column" alignItems="center">

          <Button 
          aria-label='close ad'
          size="sm" p="4px 17px" borderTop="1px solid #E2E8F0" borderX="1px solid #E2E8F0" borderRadius="8px 8px 0px 0px" bgColor="white" fontSize="12px" lineHeight="16px" fontWeight="500" onClick={handleAdClose}>
          {t("article.advertising.close")}
          </Button>
          <Box
            width="100%"
            py="18px"
            border="1px solid #EDF2F7"
            bgColor="white"
            borderRadius="8px"
          >
            <Flex w="100%" direction="column" alignItems="center" justifyContent="center">
              <Flex justifyContent="space-between" w="327px" p={{ base: "0", lg: "0 16px" }} alignItems="center" h="17px">
                <Text as="p" fontWeight="400" fontSize="9px" lineHeight="16px" color="gray.500">
                  {t("article.advertising.title")}
                </Text>
                <ChakraLink prefetch={false} as={Link} href="/contato" fontWeight="400" fontSize="8px" lineHeight="16px" color="pink.500">
                  {t("article.advertising.button")}
                </ChakraLink>
              </Flex>
              <AdsComponent currentAd={currentAd} />
            </Flex>
          </Box>
        </Flex>
      )}
    </>
  );
}

function AdsComponent({ currentAd }: { currentAd: AdsData }) {
  return (
    <ChakraLink as={Link} href={currentAd.href} isExternal>
      <Image src={currentAd.src} alt={currentAd.alt} />
    </ChakraLink>
  )
}
